if(!customElements.get('before-after')) {
  class ComponentBeforeAfter extends HTMLElement {
    constructor() {
      super();

      var slider = this.querySelector(".slider");
      var rightImg = this.querySelector(".right-img")
      
      slider.addEventListener('slider', function (e) {
        var percent = (e.detail.toFixed(2)) + "%";
        rightImg.style.clipPath = `polygon(${percent} 0, 100% 0, 100% 100%, ${percent} 100%)`;
      }, false);

      this.buttons = this.querySelectorAll(".btn.v4.drag-opener");
      this.images = this.querySelectorAll(".block-img")
      this.filterImages(this.buttons[0]);

      this.lastSelected = this.buttons[0];
      this.lastSelected.classList.add("selected");

      this.buttons.forEach(button => {
        button.addEventListener('click', () => {
          this.filterImages(button);
          this.lastSelected.classList.remove("selected");
          button.classList.add("selected");
          this.lastSelected = button;

        })
      })

      var expand = this.querySelector("button.expand");
      var toExpand = this.querySelector(".more-buttons");
      var expanded = false;
      if(expand){
        expand.addEventListener('click', () => {
          if(expanded){
            $s.collapse([toExpand]);
            expand.innerHTML = "View more";
          }
          else{
            $s.expand([toExpand]);
            expand.innerHTML = "View less";
          }
          expanded = !expanded;
        })
      }

    }

    filterImages(button){
      this.images.forEach((image)=> {
        image.style.display = image.dataset.blockId == button.dataset.blockId ? '' : 'none';
      });
    }

    

  }

   
  customElements.define('before-after', ComponentBeforeAfter);
}
